import { ADToBS } from 'components/ui/Datepicker/Datepickerutils';
import AsyncSelect from 'components/ui/Editor/AsyncSelect';
import CustomSelect from 'components/ui/Editor/CustomSelect';
import FormikValidationError from 'components/ui/FormikErrors';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import TextInput from 'components/ui/TextInput';
import { useFormik } from 'formik';
import React, { useState } from 'react';

type LecturerOption = { label: string; value: string };
import { toast } from 'react-toastify';
import { useListCoursesByTrainingQuery } from 'redux/reducers/courses';
import { useGetAvailableUserListQuery } from 'redux/reducers/internal-user';
import {
  useCreateRoutineDailySessionMutation,
  useListRoutineDailySessionByIdQuery,
  useUpdateRoutineDailySessionMutation
} from 'redux/reducers/routine';
import { useListSessionQuery } from 'redux/reducers/session-resources';
import { routineDailySessionSchema, routineDailySessionValidation } from './schema';
import { useGetAvailableLectureList } from 'service/admin.query';

type Props = {
  trainingId?: string;
  routineId?: string;
  sessionId?: string;
  open: boolean;
  toggle: () => void;
  dailySessionId?: any;
  dailySessionDetail?: any;
};
interface CustomState {
  course_topic_id: string;
  course_id: string;
}

function DailySessionModal({
  trainingId,
  routineId,
  sessionId,
  open,
  toggle,
  dailySessionId,
  dailySessionDetail
}: Props) {
  const { data: courseList = [] } = useListCoursesByTrainingQuery(routineId);

  const [initialFormState, setTrainingInitialFormState] = useState(routineDailySessionSchema);
  const [selectedLecturerOptions, setSelectedLecturerOptions] = useState<LecturerOption[]>([]);
  // const [routineDate, setRoutineDate] = useState('');

  // const { data: trainingCourseTopics = [] } = useListTrainingCourseTopicsQuery(trainingId, {
  //   skip: !trainingId
  // });
  const [createRoutineDailySession, { isLoading }] = useCreateRoutineDailySessionMutation();

  const [updateRoutineDailySession, { isLoading: isUpdating }] =
    useUpdateRoutineDailySessionMutation();

  const courseCategory = courseList?.data
    ?.map((course: any) => course.courses_list)
    ?.map((item: any) => {
      return {
        value: item.id?.toString(),
        label: item.title
      };
    });

  const { data, isLoading: SessionDataLoading } = useListRoutineDailySessionByIdQuery(
    { dailySessionId, routineId },
    { skip: !dailySessionId }
  );
  const dailySessionData = data?.data;

  React.useEffect(() => {
    if (dailySessionId && dailySessionData) {
      setTrainingInitialFormState({
        ...dailySessionData,
        routine_session: sessionId,
        course_name: dailySessionData?.course?.course_id,
        course_topic: dailySessionData?.course_topic?.id,
        routine_date: dailySessionData?.routine_date,
        routine_date_bs: dailySessionData?.routine_date_bs,
        altered_start_time: dailySessionData?.altered_start_time,
        altered_end_time: dailySessionData?.altered_end_time,
        lecturers: dailySessionData?.lecturers?.map((item: any) => item?.id.toString()),
        daily_session_id: dailySessionId
      });
      setSelectedLecturerOptions(
        dailySessionData?.lecturers?.map((l: any) => ({
          label: `${l.first_name} ${l.last_name}`,
          value: l.id.toString()
        })) ?? []
      );
      // formik.setFieldValue(
      //   'lecturers',
      //   dailySessionData?.lecturers?.map((user: any) => user?.id.toString())
      // );
      // setRoutineDate(dailySessionData?.routine_date);
    }
  }, [dailySessionData]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: routineDailySessionValidation,
    initialValues: initialFormState,

    onSubmit: async (values) => {
      values.routine_session = sessionId;
      let obj = {
        routine_session: sessionId,
        routine_date: values.routine_date,
        routine_date_bs: values.routine_date_bs,
        altered_start_time: values.altered_start_time || null,
        altered_end_time: values.altered_end_time || null,
        course_topic: values.course_topic,
        lecturers: values.lecturers,
        daily_session_id: dailySessionId,
        routine: routineId
      };
      let executeFunc = createRoutineDailySession;
      if (dailySessionId) {
        executeFunc = updateRoutineDailySession;
      }
      executeFunc(obj)
        .then((data: any) => {
          if (data?.error?.data?.non_field_errors?.length > 0) {
            data?.error?.data?.non_field_errors.map((value: any) => {
              toast.error(value);
              return;
            });
            return;
          }
          formik.resetForm({ values: routineDailySessionSchema });
          formik.setFieldValue('routine_date', '');
          formik.setFieldValue('routine_date_bs', '');
          // setRoutineDate('');
          toggle();
          toast.success('Session created successfully!');
        })
        .catch((err: any) => {
          toast.error('Error !');
        });
    }
  });

  const { data: sessionData } = useListSessionQuery(
    { id: formik?.values?.course_name, page: 1, pageSize: 1000 },
    {
      skip: !formik.values.course_name
    }
  );
  const sessionList =
    sessionData?.data?.map((item: any) => {
      return {
        value: item.course_topic_id?.toString(),
        label: item.title
      };
    }) || [];



  const { mutateAsync: getAvaiableLecturer, isLoading: isGettingAvailabel } = useGetAvailableLectureList()







  const ListSalePersonOptions = (input: string): Promise<any> => {
    return new Promise(async (resolve: any): Promise<any> => {
      // if(input?.length<3) return
      const payload = {
        sessionId, routineDate: formik.values?.routine_date, query: input
      }
      var resp: any = await getAvaiableLecturer(payload);

      const data = [...(resp?.data?.data),...(dailySessionData?.lecturers || [])] 
      var arr =
        data?.map((c: any) => {
          return {
           label:
          c.user_type === '3'
            ? `${c.first_name} ${c.last_name} ${c.mobile_number} ${c.email} (external)`
            : `${c.first_name} ${c.last_name} ${c.mobile_number} ${c.email} (internal)`,
        value: c.id.toString()
          };
        });
      resolve(arr);
    });
  };




  return (
    <form onSubmit={formik.handleSubmit}>
      <Modal
        title={`${dailySessionId ? 'Update' : 'Add'} Session`}
        isModalOpen={open}
        closeModal={() => {
          toggle();
          formik.resetForm({ values: routineDailySessionSchema });
          setSelectedLecturerOptions([]);
        }}
        modalSize="modal-md"
        renderFooter={() => (
          <div className="hstack gap-2 justify-content-end">
            <SecondaryButton
              onClick={() => {
                toggle();
                formik.resetForm({ values: routineDailySessionSchema });
                setSelectedLecturerOptions([]);
              }}
              title="Close"
            />
            <PrimaryButton
              title={`${dailySessionId ? 'Update' : 'Add'} Session`}
              iconName="align-bottom me-1"
              type="submit"
              isLoading={isLoading}
            />
          </div>
        )}>
        <CustomSelect
          containerClassName="col-12"
          options={courseCategory}
          placeholder={'Search by name'}
          value={formik.values.course_name}
          onChange={(value: any) => {
            formik.setFieldValue('course_name', value);
          }}
          label={'Course'}
        />

        <CustomSelect
          containerClassName="mt-3 col-12"
          options={sessionList}
          placeholder={'Search by name'}
          value={formik.values.course_topic}
          onChange={(value: any) => formik.setFieldValue('course_topic', value)}
          label={'Session'}
        />
        <FormikValidationError
          name="course_topic"
          errors={formik.errors}
          touched={formik.touched}
        />

        <TextInput
          containerClassName="mt-3 col-12"
          label="Date(A.D.)"
          name="routine_date"
          type="date"
          onChange={(e: any) => {
            formik.setFieldValue('routine_date', e.target.value);
            // setRoutineDate(e.target.value);
            formik.setFieldValue('routine_date_bs', ADToBS(e.target.value));
          }}
          value={formik.values.routine_date}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        {/* <NepaliDatePicker
          containerClassName="mt-3 col-12"
          label="Date(B.S.)"
          value={formik.values.routine_date_bs}
          onChange={(e) => {
            formik.setFieldValue('routine_date_bs', e);
            formik.setFieldValue('routine_date', moment(BSToAD(e)).format('YYYY-MM-DD'));
          }}
        /> */}


        <AsyncSelect
          key={formik.values.routine_date}
          containerClassName="mt-3 col-12"
          loadOptions={ListSalePersonOptions}
          defaultOptions={true}
          placeholder={'Type to search lecturer...'}
          value={selectedLecturerOptions}
          onChange={(ids: string[]) => formik.setFieldValue('lecturers', ids)}
          onChangeOption={(opts: LecturerOption[]) => setSelectedLecturerOptions(opts ?? [])}
          label={'Lecturer'}
          isMulti={true}
          isDisabled={!formik.values.routine_date}
        />
        <FormikValidationError name="lecturers" errors={formik.errors} touched={formik.touched} />

        <TextInput
          containerClassName="mt-3 col-12"
          label="Altered Start Time"
          name="altered_start_time"
          type="time"
          onChange={formik.handleChange}
          value={formik.values.altered_start_time}
          onBlur={formik.handleBlur}
          formik={formik}
          disableRequiredValidation
        />

        <TextInput
          containerClassName="mt-3 col-12"
          label="Altered End Time"
          name="altered_end_time"
          type="time"
          onChange={formik.handleChange}
          value={formik.values.altered_end_time}
          onBlur={formik.handleBlur}
          formik={formik}
          min={formik.values.altered_start_time}
          disableRequiredValidation
        />
      </Modal>
    </form>
  );
}

export default DailySessionModal;
